import styled from "styled-components";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { MEDIA_QUERIES } from "context/media/MediaConstant";

export const StyledInnerContainer = styled.div`
  padding-top: 16px;

  border-top: 1px solid ${DIGIPOSTHEME.colors.secondaryGrayTertiary};
`;

export const StyledOuterContainer = styled.div<{ paddingTop?: string }>`
  width: 646px;

  padding-top: ${({ paddingTop = "20px" }) => paddingTop};
  margin: 48px auto 0;

  @media ${MEDIA_QUERIES.MOBILE} {
    margin: 0;
    padding-top: 24px;
    width: 100%;
  }
`;

export const StyledLine = styled.div`
  padding-bottom: 10px;
  margin: 5px 0px;

  border-top: 1px solid ${DIGIPOSTHEME.colors.secondaryGrayTertiary};
`;

export const StyledRepeatButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  width: 174px;
  height: 38px;

  margin: 10px 0 48px 0;

  border-radius: 22.7px;
  border: solid 1.6px ${DIGIPOSTHEME.colors.headerRed};
  cursor: pointer;

  font-family: Campton;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: 0.5px;
  color: ${DIGIPOSTHEME.colors.headerRed};

  @media ${MEDIA_QUERIES.MOBILE} {
    margin: 13px 0 24px 0;
  }
`;
